import { render, staticRenderFns } from "./min.vue?vue&type=template&id=8547ae5e&scoped=true"
import script from "./min.vue?vue&type=script&lang=js"
export * from "./min.vue?vue&type=script&lang=js"
import style0 from "./min.vue?vue&type=style&index=0&id=8547ae5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8547ae5e",
  null
  
)

export default component.exports